import { makeStyles } from '@material-ui/core/styles';
import spacing from 'src/constants/spacing';
import mediaQueries from '../constants/mediaQueries';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'grid',

      [mediaQueries.Mobile]: {
        gridTemplateColumns: '1fr',
        padding: `0 ${spacing.Gutter.Mobile / 2}px`,
        gap: `${spacing.Gutter.Mobile / 2}px`,
      },
      [mediaQueries.Tablet]: {
        gridTemplateColumns: '1fr',
        padding: `0 ${spacing.Gutter.Tablet}px`,
        gap: `${spacing.Gutter.Tablet}px`,
      },
      [mediaQueries.Laptop]: {
        gridTemplateColumns: '1fr 1fr',
        padding: `0 ${spacing.Gutter.Laptop}px`,
        gap: `${spacing.Gutter.Laptop}px`,
      },
      [mediaQueries.Desktop]: {
        gridTemplateColumns: '1fr 1fr',
        padding: `0 ${spacing.Gutter.Desktop}px`,
        gap: `${spacing.Gutter.Desktop}px`,
      },
      [mediaQueries.BigDesktop]: {
        gridTemplateColumns: '1fr 1fr',
        padding: `0 ${spacing.Gutter.BigDesktop}px`,
        gap: `${spacing.Gutter.BigDesktop}px`,
      },

      // Portrait cells are roughly half as wide as landscape ones at the same
      // height, so fit more per row rather than leaving the rows very tall.
      '&[data-orientation="portrait"]': {
        [mediaQueries.Mobile]: {
          gridTemplateColumns: '1fr 1fr',
        },
        [mediaQueries.Tablet]: {
          gridTemplateColumns: '1fr 1fr',
        },
        [mediaQueries.Laptop]: {
          gridTemplateColumns: '1fr 1fr 1fr',
        },
        [mediaQueries.Desktop]: {
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
        },
        [mediaQueries.BigDesktop]: {
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
        },
      },
    },
    // Content belonging to the overview as a whole, set below the grid and
    // aligned to it. `.column-list` is the CMS opt-in for long name lists.
    bottomText: {
      lineHeight: 1.35,

      [mediaQueries.Mobile]: {
        padding: `${spacing.Gutter.Mobile}px ${spacing.Gutter.Mobile / 2}px 0`,
      },
      [mediaQueries.Tablet]: {
        padding: `${spacing.Gutter.Tablet}px ${spacing.Gutter.Tablet}px 0`,
      },
      [mediaQueries.Laptop]: {
        padding: `${spacing.Gutter.Laptop}px ${spacing.Gutter.Laptop}px 0`,
      },
      [mediaQueries.Desktop]: {
        padding: `${spacing.Gutter.Desktop}px ${spacing.Gutter.Desktop}px 0`,
      },
      [mediaQueries.BigDesktop]: {
        padding: `${spacing.Gutter.BigDesktop}px ${spacing.Gutter.BigDesktop}px 0`,
      },

      '& .column-list': {
        columnGap: '1.2em',
        columnCount: 2,
        [mediaQueries.Laptop]: {
          columnCount: 3,
        },
        [mediaQueries.Desktop]: {
          columnCount: 4,
        },
        [mediaQueries.BigDesktop]: {
          columnCount: 4,
        },
      },
    },
  }),
  { name: 'Overview' }
);

export default useStyles;
